import { useSelector } from 'react-redux';
import useAuth from './useAuth';

/**
 * Strict Django `is_superuser` check (NOT the looser useIsSuperAdmin, which
 * also returns true for practice ADMIN roles). Use this for anything backed by
 * an `IsSuperUser` API permission, e.g. the marketing-tracker endpoint.
 *
 * `isResolved` becomes true once the practice-user list reached a terminal
 * state: it has users, finished loading (even if empty), or failed. Callers
 * must treat "resolved and not superuser" as denied, so an empty or failed
 * list fails closed instead of spinning forever.
 */
export default function useIsSuperUser() {
    const practiceUserState = useSelector((state) => state.practiceUser);
    const { user } = useAuth();
    const results = practiceUserState?.practiceUser?.results || [];
    const me = results.find((el) => el.user && el.user.id === user?.pk);
    const inFlight = practiceUserState?.loadingPracticeId != null;
    const settled = practiceUserState?.loadedPracticeId != null || Boolean(practiceUserState?.error);
    return {
        isSuperUser: Boolean(me?.user?.is_superuser),
        isResolved: results.length > 0 || (!inFlight && settled),
    };
}
